<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div style="margin-right: 28px;">
				<CommonBtngroup ref="QuotaBtngroup" :qhide="false" @select="handSearch" @reset="handReset" />
			</div>
		</div>
		<div class="BottomTable">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportData"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<!--height="500px"-->
			<div class="Table" style="padding-right: 10px;">
				<el-table :data="tableData" style="width: 100%" v-loading="loadingTable">
					<el-table-column v-for="(item,index) in tableHead" :key="index" :label="item.title"
						:width="item.width">
						<template slot-scope="scope">
							{{scope.row[item.key]}}
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from './components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import Pagination from '../../../components/pagination.vue'
	import FromArr from './FormData/FromArrHistory'
	import utils from "../../../common/utils";
	import {
		GetOrgStockDayByInvAddCode,
		ExportOrgStockDayByInvAddCode
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableData: [],
				loadingTable: true,
				tableHead: [],
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.inventoryClassList();
			this.getData();
		},
		methods: {
			async getData() {
				this.tableHead = [];
				this.tableData = [];
				this.loadingTable = true;
				let {
					code,
					data
				} = await GetOrgStockDayByInvAddCode(this.query)
				this.loadingTable = false;
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
					if (data.data && data.data.length) {
						let titles = data.data[0];
						Object.keys(titles).forEach((it, index) => {
							this.tableHead.push({
								title: it,
								key: it,
								width: it.includes('公司') ? '150px' : '100px'
							})
						})
					}
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data,
					message
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					data.data.map((item, index) => {
						this.FromArr[0].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 导出
			async exportData() {
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.Inventory = this.FromArr[1].modelvalue;
				this.query.CompanyName = this.FromArr[2].modelvalue;

				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportOrgStockDayByInvAddCode(this.query)
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `平台库存天数列表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}

			},
			handSearch() {
				this.query.pageIndex = 1;
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.Inventory = this.FromArr[1].modelvalue;
				this.query.CompanyName = this.FromArr[2].modelvalue;
				this.query.IsAboveZero = this.FromArr[3].checked ? 1 : 0;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = ''
				})
				this.FromArr[3].checked = false;
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 120px;
		margin: 0px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background: rgb(255, 255, 255);

		.btngroup {
			position: relative;
			bottom: 0px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 4px 0px;
		margin-top: 10px;
		background: rgb(255, 255, 255);
	}
</style>